module.exports = __webpack_public_path__ + "img/thumb_2021-01.bc0db8f3.jpg";